import { useError } from 'react-use';
import { useLazyQuery } from '@apollo/client';

import { fetchListDependentsQuery } from 'api/queries';

import { ListReferencesQueryRequest, ListUsageQueryResponse } from '../../../domain';

export const useListDependentsQuery = () => {
  const dispatchError = useError();
  return useLazyQuery<ListUsageQueryResponse, ListReferencesQueryRequest>(
    fetchListDependentsQuery,
    { onError: dispatchError },
  );
};
